module.exports = __webpack_public_path__ + "static/media/ff_analytics.b39bc4e5.png";